import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RootState } from '@app/store';
import { getAppState } from '@app/store/globals';

/* *********************** *
 *    Type definitions     *
 * *********************** */
export interface AppState {
  initializing: boolean;
  fulfilled: string[];
}

/* ********************* *
 *    Slice creation     *
 * ********************* */
const initialState: AppState = {
  initializing: false,
  fulfilled: [],
};

const appSlice = createSlice({
  name: '@app/App',
  initialState,
  reducers: {},
});

/* ********************* *
 *    Export reducer     *
 * ********************* */
export default appSlice.reducer;
